import React, { forwardRef, useMemo } from 'react';
import { ColorBlock } from '@rc-component/color-picker';
import { pickAttrs } from '@rc-component/util';
import { clsx } from 'clsx';
import { isFunction } from '../../_util/is';
import { useLocale } from '../../locale';
import { getColorAlpha } from '../util';
import ColorClear from './ColorClear';
const ColorTrigger = forwardRef((props, ref) => {
    const { color, prefixCls, open, disabled, format, className, style, classNames, styles, showText, activeIndex, ...rest } = props;
    const colorTriggerPrefixCls = `${prefixCls}-trigger`;
    const colorTextPrefixCls = `${colorTriggerPrefixCls}-text`;
    const colorTextCellPrefixCls = `${colorTextPrefixCls}-cell`;
    const [locale] = useLocale('ColorPicker');
    // ============================== Text ==============================
    const desc = React.useMemo(() => {
        if (!showText) {
            return '';
        }
        if (isFunction(showText)) {
            return showText(color);
        }
        if (color.cleared) {
            return locale.transparent;
        }
        if (color.isGradient()) {
            return color.getColors().map((c, index) => {
                const inactive = activeIndex !== -1 && activeIndex !== index;
                return (React.createElement("span", { key: index, className: clsx(colorTextCellPrefixCls, inactive && `${colorTextCellPrefixCls}-inactive`) },
                    c.color.toRgbString(),
                    " ",
                    c.percent,
                    "%"));
            });
        }
        const hexString = color.toHexString().toUpperCase();
        const alpha = getColorAlpha(color);
        switch (format) {
            case 'rgb':
                return color.toRgbString();
            case 'hsb':
                return color.toHsbString();
            // case 'hex':
            default:
                return alpha < 100 ? `${hexString.slice(0, 7)},${alpha}%` : hexString;
        }
    }, [color, format, showText, activeIndex, locale.transparent, colorTextCellPrefixCls]);
    // ============================= Render =============================
    const containerNode = useMemo(() => color.cleared ? (React.createElement(ColorClear, { prefixCls: prefixCls, className: classNames.body, style: styles.body, disabled: disabled })) : (React.createElement(ColorBlock, { prefixCls: prefixCls, color: color.toCssString(), className: classNames.body, innerClassName: classNames.content, style: styles.body, innerStyle: styles.content })), [color, prefixCls, disabled, classNames.body, classNames.content, styles.body, styles.content]);
    return (React.createElement("div", { ref: ref, className: clsx(colorTriggerPrefixCls, className, classNames.root, {
            [`${colorTriggerPrefixCls}-active`]: open,
            [`${colorTriggerPrefixCls}-disabled`]: disabled,
        }), style: {
            ...styles.root,
            ...style,
        }, ...pickAttrs(rest) },
        containerNode,
        showText && (React.createElement("div", { className: clsx(colorTextPrefixCls, classNames.description), style: styles.description }, desc))));
});
export default ColorTrigger;
